import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useAuth } from "shared/lib/useAuth"

export function useLogoutViewModel() {
  const { logout } = useAuth()
  const { closeOverlay } = useCurrentOverlay()

  return {
    logout,
    onCancel: closeOverlay
  }
}
